import { animated, useSpring } from 'react-spring/web.cjs'

import PropTypes from 'prop-types';
import React from 'react';
import root from 'window-or-global';

const calc = (x, y) => [x - root.innerWidth / 2, y - root.innerHeight / 2];
const config = {
    mass: 40,
    tension: 300,
    friction: 300
}

const ParallaxWrapper = ({toRoot, className, children, speed, kill}) => {
    const [coords, setCoords] = useSpring(() => ({ xy: [0, 0], config }));
    const translation = (x, y) => `translate3d(${x / speed}px, 0, 0)`;
    //if you want to transition to root rather than element container
    const handler = React.useCallback(
        ({clientX: x, clientY: y}) => {
            setCoords({xy: calc(x,y)});
        }, [setCoords, toRoot]);

    //add and removes event listener from root when toRoot is true
    React.useEffect(() => {
        if (toRoot) {
           root.addEventListener('mousemove', handler);
        }
        return () => {
            root.removeEventListener('mousemove', handler);
        }
    }, [toRoot, root, handler]);
    return(
        <div
            className={`parallax-container ${className || ''}`} 
            onMouseMove={toRoot ? null :  ({ clientX: x, clientY: y }) => setCoords({ xy: calc(x, y) })}>
            <animated.div
                className="parallax-layer"
                style={{transform: kill ? 'translate3d(0,0,0)' : coords.xy.interpolate(translation)}}>
                {children}
            </animated.div>
        </div>
    );
}

ParallaxWrapper.propTypes = {
    toRoot: PropTypes.bool,
    className: PropTypes.string,
    children: PropTypes.object,
    speed: PropTypes.number,
    kill: PropTypes.bool
};

export default ParallaxWrapper;
